

//Customer selector 
export const selectCustomersList = (state) => state.sales?.customersList;
export const selectCustomersLoading = (state) => state.sales.loading;
export const selectError = (state) => state.sales.error;




// Sales Selector
export const selectSalesVoucherNumber = (state) => state.sales.salesVoucherNumber;


export const selectDefaultAccount = (state)=> state.sales.defaultAccount